import React, { useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import NewReport from '../Report/NewReport';
import studyReportContext from '../../context/studyreport/StudyReportContext';
import UserContext from '../../context/users/UserContext';

const NewReportWidget = (props) => {
  const { studyId, firmId } = props;
  const {
    setFirmId,
    setStudyId,
    setStudyParentId,
    modality,
    setIsExternal,
    setIsClientReportExistExternalModal,
    setKeyImagePresentStudyList,
    setDisablePreview,
    setDisableSave,
    setDisableSubmit,
    setDisableDownload,
    setDisableRaiseAlert,
    setIsWidget
  } = useContext(studyReportContext);

  const { authenticated, loadByUsername } = useContext(UserContext);
  // const [searchParams] = useSearchParams();
  // const studyId = searchParams.get('studyId');
  // const firmId = searchParams.get('firmId');

  useEffect(() => { 
    console.log("hii inside useeff : ", firmId);
    if (firmId) setFirmId(firmId);
    if (studyId) {
      setStudyId(studyId);
      setStudyParentId(studyId);
    }
    setIsWidget(true);
    setIsClientReportExistExternalModal(false);
    setKeyImagePresentStudyList(false);

    try {
      setDisablePreview(false);
      setDisableSave(false);
      setDisableSubmit(false);
      setDisableDownload(false);
      setDisableRaiseAlert(false);
    } catch (e) {}
    window.parent.postMessage({ type: "iframe-ready" }, "*");
  }, [firmId, studyId]);

  useEffect(() => {
    if (!authenticated && typeof loadByUsername === 'function') {
      loadByUsername();
    }
  }, [authenticated, loadByUsername]);

  return (
    <NewReport
      {...props}
      activeStudyId={studyId}
      modality={modality}
      showPathologyOptions={false}
      customHeight={500}
      qcData={null}
      keyImages={0}
      annotationData={null}
      activeViewportIndex={null}
      isStudyList={false}
    />
  );
};

export default NewReportWidget;
